export default __webpack_public_path__ + "static/media/hotbit.7f54c9a3.svg";